export const CREATE_WALLET_REQUEST = `
mutation createWalletRequest(
  $input:CreateWalletRequestInput!,
  $tenant_id: Int!,
  $files: [Upload!]
){
  createWalletRequest(
    input:$input,
    tenant_id:$tenant_id,
    files:$files
  ){
    __typename
    ...on WalletRequest{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const DELETE_WALLET_REQUEST = `
mutation deleteWalletRequest(
  $tenant_id: Int!
  $id: Int!
){
  deleteWalletRequest(
    tenant_id:$tenant_id,
    id:$id
  ){
    __typename
    ...on WalletRequest{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const UPDATE_WALLET_REQUEST = `
mutation updateWalletRequest(
  $tenant_id: Int!
  $input: UpdateWalletRequestInput!
  $files: [Upload!]
){
  updateWalletRequest(
    tenant_id:$tenant_id,
    input:$input,
    files:$files
  ){
    __typename
    ...on WalletRequest{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
